import api from '../api';

export interface Department {
    id: string;
    companyId: string;
    name: string;
    description?: string;
    active: boolean;
    createdAt: string;
    updatedAt: string;
    employeeCount?: number;
}

export interface CreateDepartmentData {
    name: string;
    description?: string;
}

export interface UpdateDepartmentData {
    name?: string;
    description?: string;
    active?: boolean;
}

export const departmentsApi = {
    /**
     * Obtener todos los departamentos de la empresa
     */
    async getDepartments(): Promise<Department[]> {
        const response = await api.get<{ success: boolean; data: Department[] }>('/api/departments');
        return (response.data as unknown as Department[]) ?? [];
    },

    /**
     * Obtener estadísticas de departamentos
     */
    async getDepartmentStats(): Promise<any> {
        const response = await api.get<{ success: boolean; data: any }>('/api/departments/stats');
        return response.data as unknown as any ?? {};
    },

    /**
     * Obtener un departamento por ID
     */
    async getDepartmentById(id: string): Promise<Department> {
        const response = await api.get<{ success: boolean; data: Department }>(`/api/departments/${id}`);
        if (!response.data) {
            throw new Error('Departamento no encontrado');
        }
        return response.data as unknown as Department;
    },

    /**
     * Crear un nuevo departamento
     */
    async createDepartment(data: CreateDepartmentData): Promise<Department> {
        const response = await api.post<{ success: boolean; data: Department; message: string }>('/api/departments', data);
        if (!response.data) {
            throw new Error('Error al crear departamento');
        }
        return response.data as unknown as Department;
    },

    /**
     * Actualizar un departamento
     */
    async updateDepartment(id: string, data: UpdateDepartmentData): Promise<Department> {
        const response = await api.put<{ success: boolean; data: Department; message: string }>(`/api/departments/${id}`, data);
        if (!response.data) {
            throw new Error('Error al actualizar departamento');
        }
        return response.data as unknown as Department;
    },

    /**
     * Eliminar un departamento
     */
    async deleteDepartment(id: string): Promise<{ success: boolean; message: string }> {
        const response = await api.delete<{ success: boolean; message: string }>(`/api/departments/${id}`);
        if (!response) {
            return { success: false, message: 'Error al eliminar departamento' };
        }
        return response as unknown as { success: boolean; message: string };
    },
};
